import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "Navigation/Link";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { PaypointsList } from "Components/Paypoints/PaypointsList";
import type { MerchantAppProductDto } from "Infrastructure/Api/Api";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";
import { usePayPointsQuery } from "Api/Queries/PayPoints/usePayPointsQuery";
import { activeFirstSort } from "Components/Paypoints/utils";
import { isTerminalProductCode } from "Components/Shared/Merchant/Products/AppProducts/constants";

const RESOURCES = Resources.Paypoint;

type Props = {
  products: Array<MerchantAppProductDto>;
  merchantPublicID?: string;
  isReadOnly?: boolean;
};

export const PayPoints = ({
  products,
  merchantPublicID,
  isReadOnly = false,
}: Props) => {
  const { t } = useResource();
  const { data, isLoading } = usePayPointsQuery(0, 1000, merchantPublicID);

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  const paypoints = data?.items || [];

  return (
    <Stack gap={10}>
      {products.map(
        ({ productDto: { code, name, nfcPayPointsLimit, productID } }) => {
          const filteredPaypoints = paypoints
            .filter((paypoint) => paypoint.productID === productID)
            .sort(activeFirstSort);

          const isTerminalProduct = isTerminalProductCode(code);

          return (
            <PaypointsList
              key={code}
              title={name}
              limit={isTerminalProduct ? null : nfcPayPointsLimit}
              paypoints={filteredPaypoints}
              productID={productID}
              productCode={code}
              merchantPublicID={merchantPublicID}
              isReadOnly={isReadOnly}
            />
          );
        },
      )}
      <Box>
        <PaypointsList
          title={t(RESOURCES.Individual)}
          limit={0}
          paypoints={[]}
          productID={null}
          merchantPublicID={merchantPublicID}
          isReadOnly={isReadOnly}
        />
        <Box display="flex">
          <Button
            component={Link}
            type="button"
            color="primary"
            variant="text"
            to="TODO"
            disabled
            endIcon={<ArrowForwardOutlinedIcon height="12px" />}
          >
            {t(RESOURCES.SeeOptions)}
          </Button>
        </Box>
        <Typography variant="body1" color="text.secondary">
          {t(RESOURCES.IndividualUnderConstruction)}
        </Typography>
      </Box>
    </Stack>
  );
};
